'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_997b7aad = {"container":"Logo_module_container__9fe877b5","important":"Logo_module_important__9fe877b5","text-wrapper":"Logo_module_textWrapper__9fe877b5"};
require("../../../assets/cjs/components/Logo/src/Logo~BvU6MKTQ.css");

exports.default = modules_997b7aad;
//# sourceMappingURL=Logo.module.less.js.map
